import { IContactGroup } from '@dataTypes/contact.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_CONTACT')

const headers = {
  'Content-Type': 'application/json',
}

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type ContactGroupsResponseData = {
  contact_groups?: IContactGroup[]
}

type ContactGroupResponseData = {
  contact_group?: IContactGroup
}

type GetAllContactGroupsResponse = ApiResponse<ContactGroupsResponseData>
type ContactGroupResponse = ApiResponse<ContactGroupResponseData>

// Function to get all contact groups
export const getAllContactGroups =
  async (): Promise<GetAllContactGroupsResponse> => {
    try {
      const response = await axios.get<GetAllContactGroupsResponse>(
        `${BUSINESS_LAYER_API}/api/v1/contact/group/all`,
        {
          headers,
        },
      )

      return response.data
    } catch (e) {
      throw toApiError(e, 'An unknown error occurred')
    }
  }

export const updateContactGroupById = async (
  contact_group_id: string,
  updatedData: Partial<IContactGroup>,
): Promise<ContactGroupResponse> => {
  try {
    const response = await axios.put<ContactGroupResponse>(
      `${BUSINESS_LAYER_API}/api/v1/contact/group`,
      { contact_group_id, data: updatedData },
      {
        headers,
      },
    )

    return response.data
  } catch (e) {
    logger.error('Error in updateContactGroupById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const createContactGroup = async (
  groupDetails: IContactGroup,
): Promise<ContactGroupResponse> => {
  try {
    const response = await axios.post<ContactGroupResponse>(
      `${BUSINESS_LAYER_API}/api/v1/contact/group`,
      groupDetails,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createContactGroup:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteContactGroupById = async (
  contactGroupId: string,
): Promise<ContactGroupResponse> => {
  try {
    const response = await axios.delete<ContactGroupResponse>(
      `${BUSINESS_LAYER_API}/api/v1/contact/group/${contactGroupId}`,
      {
        headers,
      },
    )
    return response.data
  } catch (e) {
    throw toApiError(e, 'An unknown error occurred')
  }
}
